{
    "AgentOmnichannel_AllowAnsweringConcurrent": "Consentire la risposta a canali contemporanei:",
    "AgentOmnichannel_Chat_IntegrationType": "Chat Tipo di integrazione:",
    "AgentOmnichannel_Chat_IDOnChatSystem": "ID sul sistema di chat:",
    "AgentOmnichannel_Chat_LiveChatAgentID": "ID agente Livechat:",
    "AgentOmnichannel_Email_IntegrationType": "Tipo di integrazione e-mail:",
    "AgentOmnichannel_Email_EmailAddress": "Indirizzo e-mail:",
    "AgentOmnichannel_Email_IDOnEmailSystem": "ID sul sistema di posta elettronica:",
    "AgentOmnichannel_Chat_IntegrationTypes_None": "[Nessuno]",
    "AgentOmnichannel_Chat_IntegrationTypes_LiveChat": "LiveChat",
    "AgentOmnichannel_Email_IntegrationTypes_None": "[Nessuno]",
    "AgentOmnichannel_Email_IntegrationTypes_Pop3": "Posta elettronica (POP3 e SMTP)",
    "AgentOmnichannel_Email_EmailAddress_Invalid": "L'indirizzo e-mail non è valido",
    "NAME": "AgentOmnichannel"
}